import type { FaireProductEntity } from "../../entity_types/product";

export const p_7aynmddb8j: FaireProductEntity = {
  token: "p_7aynmddb8j",
  type: "product",
  name: "Pure Copper Meru Yantra / Meru Shree Yantra /Solid copper",
  brandToken: "b_qyxxvd286n",
  brandName: "jiomind",
  imageUrl:
    "https://cdn.faire.com/fastly/89789418448a9f3319a92cdee21c5196dd98f4a56c87af1413cd68b8fbe88ec1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/22d0c6da2c229f04b7c110303a638c00f05010e14f86265b8878de099ad20adf.jpeg",
    "https://cdn.faire.com/fastly/918ed73924f2e29eb009ce06cbc805f3709f89b708e63235eb94a56dc00c0838.jpeg",
  ],
  priceDollars: 311.78,
  description:
    "Pure Copper Meru Shree Yantra \n================================\n- Size :  6 x 6 inches\n- Weight 3 to 3.5kgs\n- Solid\n- Made from pure Copper\n==============================\n\nShree Yantra is a holy instrument which has a mythological connection with Goddess Lakshmi, the Hindu deity of fortune, prosperity, and wealth. Hindu religion is hailed for its age-old Vedic culture and traditions. It has drawn the curiosity of many philosophers and scientists from across the world. Yantra is a Sanskrit word which means any object or a geometric diagram which is used in a tantric worship as a meditation aid.\n\nAncient Vedic Texts stipulate that even a mere presence of this Yantra in a household or at any other place bestows Success, Happiness, Mental Peace as well as Health, Wealth and Harmony. This Yantra is said to correct all kind of Doshas including the Vaastu Dosha",
  tags: [],
  msrpDollars: 623.56,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:47.057Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
